import React from 'react';
import { ReactComponent as Underline } from '../../../assets/images/underline.svg';
import OrdersReceivedStat from 'components/logistics/stats/order_received';
import { OrderStat } from '.';

type Props = {
  loading: boolean;
  data: OrderStat;
};
const LogisticsStatsPageTwo = ({ loading, data }: Props) => {
  const totalOrders =
    parseInt(data?.success_order_count ?? 0) + parseInt(data?.failed_order_count ?? 0);
  return (
    <div>
      <div className='intro'>
        <div>
          <h3 className='mb-6 intro_heading'>The team has been cooking 👩🏾‍🍳</h3>
        </div>
        <p className='orders-recieved'>{totalOrders} orders recieved</p>
        <Underline />

        <p className='inkfree font-medium py-3 text-[16px] mb-3 mt-1'>THIS IS HOW WE FARED</p>
        <OrdersReceivedStat data={data} loading={loading} />
      </div>
    </div>
  );
};
export default LogisticsStatsPageTwo;
